module.exports = __webpack_public_path__ + "img/collage.7880dc9e.jpg";